<template>
    <div class="flex justify-center items-center">
        <div :class="`flex flex-col items-center min-w-56 ${maxWidthClass} px-8 py-4 rounded-md shadow-xl bg-white space-y-2 text-center`">
            <nio-icon class="text-6xl" :name="icon" v-if="icon" />
            <slot name="title">
                <h3 class="text-xl" v-text="title" />
            </slot>
            <slot name="description">
                <p v-text="description" />
            </slot>
            <span class="pt-2" v-if="$slots.default">
                <slot />
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            maxWidthClass: {
                type: String,
                default: 'max-w-96',
            },
            icon: {
                type: String,
                default: '',
            },
            title: {
                type: String,
                default: '',
            },
            description: {
                type: String,
                default: '',
            },
        },
    };
</script>
